import { render } from "./addModuleNotice.vue?vue&type=template&id=c14fb560"
import script from "./addModuleNotice.vue?vue&type=script&lang=js"
export * from "./addModuleNotice.vue?vue&type=script&lang=js"

import "./addModuleNotice.vue?vue&type=style&index=0&id=c14fb560&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__